import { Content } from './Content/Content';
import { Header } from './Header/Header';
import { Wrapper } from './Wrapper/Wrapper';

export const UiDetailsCard = {
  Wrapper: Wrapper,
  Header: Header,
  Content: Content,
};
